import { Placeholder } from '../Placeholder/Placeholder';

export const ArticleBodyRendererLoader = () => (
  <>
    {new Array(2).fill(undefined).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index} className="mt-5 flex flex-col gap-y-1">
        <Placeholder className="h-4 w-full rounded-sm" />
        <Placeholder className="h-4 w-full rounded-sm" />
        <Placeholder className="h-4 w-full rounded-sm" />
        <Placeholder className="h-4 w-full rounded-sm" />
        <Placeholder className="h-4 w-full rounded-sm" />
        <Placeholder className="h-4 w-3/4 rounded-sm" />
      </div>
    ))}
  </>
);
